import { FC, ReactNode } from "react";

import styles from "./article-content-styles.module.scss";

type Props = {
    children: ReactNode;
    className?: string;
};

const ArticleContentStyles: FC<Props> = ({ children, className }) => (
    <div className={`${styles.root} ${className ?? ""}`.trim()}>{children}</div>
);

export default ArticleContentStyles;
